'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import {epicErrorHandler} from '../../../core-utilities/rx-utils';
// import {ORGANIZATION_COLLECTION} from '../../../organizations/domain/config';
// import {PROJECT_COLLECTION} from '../../../projects/domain/ProjectDomain';
// import {ASSET_PROJECT_COLLECTION} from '../../../projects/domain/AssetProjectDomain';
// import {ASSET_COLLECTION} from '../../../assets/domain/AssetDomain';
import {
  assignAssetToModel,
  assignOrganizationToModel,
  assignProjectToModel,
  selectedAsset,
  selectedOrganization,
  selectedProject,
} from '../actions';
import {logger} from './logger';

export const epics = [
  onSelectedOrganizationEpic,
  onSelectedProjectEpic,
  onSelectedAssetEpic,
];

onSelectedOrganizationEpic.$inject = onSelectedProjectEpic.$inject = onSelectedAssetEpic.$inject = [
  'OrganizationDomain',
  'AssetDomain',
  'AssetProjectDomain',
  'ProjectDomain',
];

export function onSelectedOrganizationEpic(action$, store, dependencies) {
  return makeSelectedEpic(
    action$,
    store,
    dependencies,
    'onSelectedOrganizationEpic',
    selectedOrganization.TYPE,
    assignOrganizationToModel,
    'OrganizationDomain',
  );
}

export function onSelectedProjectEpic(action$, store, dependencies) {
  return makeSelectedEpic(
    action$,
    store,
    dependencies,
    'onSelectedProjectEpic',
    selectedProject.TYPE,
    assignProjectToModel,
    'ProjectDomain',
  );
}

export function onSelectedAssetEpic(action$, store, dependencies) {
  return makeSelectedEpic(
    action$,
    store,
    dependencies,
    'onSelectedAssetEpic',
    selectedAsset.TYPE,
    assignAssetToModel,
    'AssetDomain',
  );
}


// TODO: error handling
function makeSelectedEpic(action$, store, dependencies, epicName, actionType, assignAction, domainClassName) {
  return action$.ofType(actionType)
    .switchMap((action) =>
      action.payload.id
        ? dependencies[domainClassName]
          .$get(action.payload.id)
          .then(assignAction)
          .catch(err => {
            logger.error({err}, `Failed to retrieve domain ${action.payload.id} for ${epicName}`);
            return assignAction(null);
          })
        : Observable.of(assignAction(null))
    )
    .filter((action) => action !== null)
    .catch(epicErrorHandler(logger, epicName));
}

// export function selectedOrganizationEpic(action$, store, dependencies) {
//   return makeSelectedEpic(action$, store, dependencies, selectedOrganization.TYPE, assignOrganizationToModel, ORGANIZATION_COLLECTION);
// }
//
// export function selectedProjectEpic(action$, store, dependencies) {
//   return makeSelectedEpic(action$, store, dependencies, selectedProject.TYPE, assignProjectToModel, PROJECT_COLLECTION);
// }
//
// export function selectedAssetEpic(action$, store, dependencies) {
//   return makeSelectedEpic(action$, store, dependencies, selectedAsset.TYPE, assignAssetToModel, ASSET_COLLECTION);
// }
//
//
// function makeSelectedEpic(action$, store, dependencies, actionType, assignAction, collection) {
//   return action$.ofType(actionType)
//     .switchMap((action) =>
//       !action.payload.id
//         ? Observable.empty()
//         : dependencies
//           .FirebaseUtil
//           .firebaseRef(`${collection}/${action.payload.id}`)
//           .observe('value')
//           .map((ss) => assignAction({
//             ...ss.val(),
//             id: action.payload.id,
//             collection,
//           }))
//     );
// }



// WEBPACK FOOTER //
// ./src/js/app/model/epics/selectedDomain.js